import {useArchiveContext} from "../../context/ArchiveContext";
import Form from "./Form";
import {useEffect, useState} from "react";
import InputText from "../fields/InputText";
import InputDate from "../fields/InputDate";
import InputTextArea from "../fields/InputTextArea";
import SubmitButton from "../buttons/SubmitButton";
import {updateArchiveContent} from "../../clients/ArchiveApiClient";
import sendSuccessAlert from "../../services/alertService";

const EditArchiveContent = () => {

    const {refresh, redactedArchive, setRedactedArchive, isRedacted, setIsRedacted} = useArchiveContext();
    const [title, setTitle] = useState("");
    const [author, setAuthor] = useState("");
    const [description, setDescription] = useState("");
    const [date, setDate] = useState(new Date());
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (redactedArchive === null) {
            return;
        }
        setTitle(redactedArchive?.title || '');
        setAuthor(redactedArchive?.author || '');
        setDescription(redactedArchive?.description || '');
        setDate(new Date(redactedArchive?.created_at) || new Date());
    }, [redactedArchive]);

    if (!isRedacted) return null;

    function disable() {
        return title?.length === 0 ||
            description?.length === 0 ||
            date?.length === 0;
    }

    function close() {
        setIsRedacted(false);
    }

    async function onSubmit(e) {
        e.preventDefault();
        setLoading(true);
        const id = redactedArchive?.id;
        updateArchiveContent(id, title, author, description, date)
            .then(() => {
                setRedactedArchive(false);
                close();
                sendSuccessAlert('Контент успешно изменён')
                refresh();
            })
            .catch((err) => {
                console.error('Error to edit archive content', err);
            })
            .finally(() => setLoading(false));
    }

    return (
        <div>
            <Form
                onClose={close}
                title={'Редактирование контента'}
                onSubmit={onSubmit}
            >
                <InputText
                    text={'Название'}
                    placeholder={'Укажите название'}
                    value={title}
                    onChange={e => setTitle(e.target.value)}
                    required={true}
                />

                <InputText
                    text={'Автор'}
                    placeholder={'Укажите автора'}
                    value={author}
                    onChange={e => setAuthor(e.target.value)}
                />

                <InputDate
                    text={'Дата создания'}
                    placeholder={"Укажите дута"}
                    value={date}
                    onChange={e => setDate(e)}
                />
                <InputTextArea
                    text={'Описание контента'}
                    placeholder={'Опишите контент'}
                    value={description}
                    onChange={e => setDescription(e)}
                />

                <SubmitButton
                    text={'Редактировать новость'}
                    disabled={disable()}
                    isAnimating={loading}
                />
            </Form>
        </div>
    )
}

export default EditArchiveContent;